import apiUrl from '../../../constants';
import axios from 'axios';
//import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import download from 'downloadjs';
import Pagination from './../shared/pagination'
import JsonExcel from "vue-json-excel";
import Vue from "vue";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import csvHelper from '../reports/importjsontocsv';
Vue.component("downloadExcel", JsonExcel);


export default {
    name: 'stockageingreport',
    components: {
        //Paginate,
        BasicSelect,
        Pagination,
        Loader,
        DatePicker,
        JsonExcel,
        download,
    },
    data: function () {
        return {
            formattedDate: '',
            currentPage: 1,
            totalPage: 0,
            totalCount: 0,
            pageLimit: 10,
            showSelectWarehouse: false,
            isLoading: false,
            showSelectClient: false,
            searchFlag1: false,
            searchFlag: false,
            processstatus: '',
            checkstatus: '',
            ProductID: '',
            listWarehouseData: [],
            listClientData: [],
            listProductRackData: [],
            listMerchantData: [],
            listbrandData: [],
            fromdate: '',
            todate: '',
            warehouse: '',
            brand: '',
            rto_srid: '',
            Merchant: '',
            WarehouseErr: '',
            days: '',
            MerchantErr: '',
            warehouseid: '',
            user_type: '',
            client: '',
            racktype: '',
            clientid: '',
            ClientErr: '',
            lineno: '',
            rackno: '',
            sectionid: '',
            listProductRackDataCsv: '',
            brand: '',
            userid: '',
            rackuti: '',
            rtoid: '',
            listReportDataforxls: [],
            csvFieldsForXls: {},
            reportname: '',
            show: '',
            download: true,
            racktype: '',
            racktypeErr: '',
            orderby: 'DESC',
            errormsg: false,
            type: '',
            selectedbrand: { value: '', text: '' },
            brandList: [],
            limitExeed: false,
            showdownload: false,
            selectedmerchant: { value: '', text: '' },
            merchantList: [],
            Merchant: '',
            merchantid: '',
            showSelectMerchant: false,
            withrackid: false,
            enable: '',
            viewrackids: false,
            productids: ''
        }
    },
    filters: {
        moment: function (date) {
            if (date)
                return moment(date).format('DD-MM-YYYY HH:mm:ss');
            else {
                return '';
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },

    mounted() {
        var today = new Date();
        this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.useremail = userdetail.email;
        var loginuseremail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        // this.warehouse = userdetail.warehouseid;
        this.clientid = userdetail.clientid;
        this.loginClientUserId = userdetail.clientid;
        this.loginuserid = userdetail.userid;
        this.userid = userdetail.userid;
        this.user_type = userdetail.utype;
        this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantData();
        this.getBrandlist();
        }
        this.reportname = this.$t('editedjson.Stockageingreport')
        this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';

        switch (this.user_type) {
            case 'system_user':

                this.showSelectWarehouse = true;
                this.showSelectClient = true;
                this.showSelectMerchant = true
                // this.getWarehouseList();
                // this.getClientList();
                break;

            case 'client_user':
                this.clientid = userdetail.clientid;
                this.client = this.clientid;
                // this.getClientList();
                this.getWarehouseList();
                this.getMerchantData();
                this.getBrandlist();
                this.showSelectMerchant = true
                this.showSelectWarehouse = true;
                break;

            case 'warehouse_user':
                this.loginUserEmail = userdetail.email;
                this.warehouse = userdetail.warehouseid;
                this.warehouseid = userdetail.warehouseid;
                this.showSelectClient = true;
                this.showSelectMerchant = true
                // this.getWarehouseList();
                // this.getClientList();
                break;

            default:
                this.$alertify.error(this.$t('common.unauthorisedError'));
                break
        }
        this.getRecordLimit()
    },
    methods: {
        selectMerchant(data) {
            this.selectedmerchant = data;
            this.merchantid = data.value;
        },
        selectbrand(data) {
            this.selectedbrand = data;
            if (data.text != this.$t('common.selectBrandPlaceHolder')) {
                this.brand = data.text;
            } else {
                this.brand = ''
            }
        },
        filters: {
            moment: function (date) {
                if (!date) return '';
                return moment(date).format('DD-MM-YY hh:mm:ss');
            }
        },
        jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter = []) {

            var csvData = '';
            //Header
            if (this.title != null) {
                csvData += this.parseExtraData(this.title, '${data}\r\n')
            }
            csvData += ''
            Object.entries(dataFilter).forEach(([k, v]) => {
                csvData += k + ':' + v + ','
            })
            csvData += '\r\n'
            csvData += '\r\n'
            //Fields
            for (let key in data[0]) {
                if (skipFilter.indexOf(key) == -1)
                    csvData += csvfield[key] + ',';
            }
            csvData = csvData.slice(0, csvData.length - 1);
            csvData += '\r\n';
            //Data
            data.map(function (item) {
                for (let key in item) {
                    if (skipFilter.indexOf(key) == -1) {
                        var escapedCSV = item[key] + ''; // cast Numbers to string
                        if (escapedCSV.match(/[,"\n]/)) {
                            escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
                        }
                        if (escapedCSV == 'null')
                            csvData += ',';
                        else {
                            if (dateFilter.indexOf(key) != -1)
                                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
                            else
                                csvData += escapedCSV + ',';
                        }
                    }
                }
                csvData = csvData.slice(0, csvData.length - 1);
                csvData += '\r\n';
            })
            //Footer
            if (this.footer != null) {
                csvData += this.parseExtraData(this.footer, '${data}\r\n');
            }
            filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
            return this.export(csvData, filename, "application/csv");
            return csvData;
        },

        export(data, filename, mime) {
            let blob = this.base64ToBlob(data, mime);
            download(blob, filename, mime);
        },

        base64ToBlob(data, mime) {
            let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
            let bstr = atob(base64);
            let n = bstr.length;
            let u8arr = new Uint8ClampedArray(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            })
        },
        getNotinPOReportserach() {
            this.currentPage = 1;
            this.searchFlag = true;
            this.csvCheck = 1;
            this.offset = 0;
            this.getStockageingReport(2);
        },
        getMerchantData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
                clientid: localStorage.getItem("selectedClient"),
            });
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'merchantList',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    this.listMerchantData = result.data
                    this.merchantList.push({
                        value: '', text: this.$t('common.selectMerchantPlaceHolder')
                    }
                    )
                    for (var i = 0; i < this.listMerchantData.length; i++) {
                        this.merchantList.push({
                            'value': this.listMerchantData[i].merchantid,
                            'text': this.listMerchantData[i].merchantname
                        });
                    }
                }, error => {
                    console.error(error)
                })
        },
        // getClientList() {
        //     if (window.localStorage.getItem("clientList") !== null) {
        //         var clientListEncrypt = window.localStorage.getItem('clientList');
        //         var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        //         var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        //         this.listClientData = JSON.parse(plaintextclient);
        //     }
        //     else {
        //         var userToken = window.localStorage.getItem('userToken');
        //         var myStr = userToken.replace(/"/g, '');
        //         this.pageno = this.totalPage = 0;

        //         if (this.warehouseid)
        //             this.input = ({
        //                 warehouseid: this.warehouseid,
        //             });
        //         else {
        //             this.input = {};
        //         }
        //         axios({
        //             method: 'POST',
        //             'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
        //             'data': this.input,
        //             headers: {
        //                 'Authorization': 'Bearer ' + myStr,
        //             }
        //         })
        //             .then(result => {
        //                 this.listClientData = result.data.data;

        //             }, error => {
        //                 console.error(error);
        //             });
        //     }
        // },


        // getWarehouseList() {
        //     var userToken = window.localStorage.getItem('userToken')
        //     var myStr = userToken.replace(/"/g, '');
        //     this.pageno = 0;
        //     this.input = ({
        //         'clientid': this.client,
        //     });
        //     axios({
        //         method: 'POST',
        //         'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
        //         'data': this.input,
        //         headers: {
        //             'Authorization': 'Bearer ' + myStr
        //         }
        //     })
        //         .then(result => {
        //             this.listWarehouseData = result.data.data;
        //         }, error => {
        //             console.error(error)
        //         })
        // },
        // clientSelected() {
        //     if (this.clientid != this.client || this.clientid == this.client) {
        //         this.clientid = this.client;
        //         this.getBrandlist();
        //         this.merchantid = ''
        //         this.merchantList = []
        //         this.selectedmerchant = {}
        //         this.getMerchantData();
        //         if (this.user_type != 'warehouse_user') {
        //             this.listWarehouseData = []
        //             this.brandList = []
        //             this.getWarehouseList();

        //             if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
        //                 this.warehouse = this.warehouseid = '';
        //             } else {
        //                 //this.merchantList=[]
        //                 this.warehouse = ''

        //             }
        //         }
        //     }
        //     this.brandList = []
        //     this.listRackinData = [];
        //     this.pageno = this.totalPage = 0;
        //     this.rackuti = ''
        // },

        // warehouseSelected() {
        //     this.warehouseid = this.warehouse;
        //     this.pageno = this.totalPage = 0;
        // },
        startDownload() {
            this.isLoadingforxls = true;
        },
        finishDownload() {
            this.isLoadingforxls = false;
        },
        mode(order) {
            if (this.searchFlag == true && this.client != '' && this.warehouse != '') {
                this.listProductRackData = []
                if (order == 'ASC') {
                    this.orderby = 'ASC'
                }
                else {
                    this.orderby = 'DESC'
                }
                this.showdownload = true
                this.getStockageingReport()
                if (!this.limitExeed) {
                    this.getStockageingReportXls(3)
                }
            }
        },
        Choosetype() {
            this.show = true;
            this.download = false;
            if (!this.limitExeed) {
                this.getStockageingReportXls(3)
            }
        },
        getStockageingReportXls(csvCheck = 0) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            var dataFilter = {};
            if (this.showdownload == false) {
                this.show = true;
                this.download = false;
            } else {
                this.show = false;
                this.download = true;
            }
            this.dataFilter2 = [];
            var value = '';
            var str = '';
            var to_date = '';

            if (this.todate) {
                to_date = this.dateFormat(this.todate)
            }
            this.input = ({
                limit: this.pageLimit,
                todate: to_date,
                offset: (this.currentPage - 1) * 10,
                productid: this.ProductID.trim(),
                brand: this.brand,
                userid: this.userid,
                csvData: csvCheck,
                merchantid: this.merchantid,
                racktype: this.racktype,
                orderby: this.orderby,
                checkrack: this.withrackid

            });
            let client = this.client.toString()
            let warehouse = this.warehouse.toString()
            let Filterdwarehousename = this.listWarehouseData.filter(function (el) { return el.warehouseid == warehouse })
            let Filterdclientname = this.listClientData.filter(function (el) { return el.clientid == client });
            this.input.clientname = Filterdclientname[0].clientname
            this.input.warehousename = Filterdwarehousename[0].warehousename
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    value += k + ':' + v + ','
                    this.dataFilter2 = str.concat(value);
                }
            })
            delete this.input.clientname
            delete this.input.warehousename
            this.input.clientid = localStorage.getItem("selectedClient")
            this.input.warehouseid = localStorage.getItem("selectedWarehouse")
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'stockageingreport',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    this.showdownload = false
                    if (csvCheck == 3) {
                        if (result.data.data.length > 0) {
                            this.listReportDataforxls = [];
                            this.csvFieldsForXls =[];
                            this.csvFieldsForXls[this.$t('product.clientProductId')] =  'clientproductid',
                            this.csvFieldsForXls[this.$t('product.productId')] ='productid',
                                this.csvFieldsForXls[this.$t('product.clientProductId')] =  'clientproductid',
                                this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode',
                                this.csvFieldsForXls[this.$t('printProductDetails.productName')] =  'productname',
                                this.csvFieldsForXls[this.$t('common.brand')] =  'brand',
                                this.csvFieldsForXls[this.$t('packingReportList.table.columns.merchantName')] = 'merchantname',
                                this.csvFieldsForXls[this.$t('editedjson.stockTyped')]  = 'racktype',
                                this.csvFieldsForXls[this.$t('inwardList.printData.printBarcode.heading')]  =  'quantity',
                                this.csvFieldsForXls[this.$t('stockAgeingReport.table.drId')]  = 'invreferenceid',
                                this.csvFieldsForXls[this.$t('editedjson.ageIndays')]  = 'diff days',
                                this.csvFieldsForXls[this.$t('removeHold.drDatetime')]  =  'drdatetime',
                            this.withrackid = document.getElementById("withracks").checked ? true : false
                            if (this.withrackid)
                                this.csvFieldsForXls['Rack ID'] = 'rackid'

                            for (let i = 0; i < result.data.data.length; i++) {
                                let tempfinalArray = result.data.data[i];
                                this.listReportDataforxls.push(tempfinalArray);
                            }
                        } else {

                            if (result.data.status == true) {

                                this.$alertify.success(this.$t('common.reportSizeError'));
                            } else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }
                    }

                }, error => {
                    console.error(error);
                })
        },
        calldateFunction: function () {

            this.todate = '';
            this.fromdate = '';
            var cdays = this.days;

            this.currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
            this.fromdate = this.currentDate;
            var someDate = moment().subtract(cdays, 'd').format('YYYY-MM-DD HH:mm:ss');
            this.todate = someDate;
        },


        dateFormat(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        dateFormatFRT(date) {
            if (!date) return '';
            return moment(date).format('DD-MM-YY HH:mm:ss');
        },

        getStockageingReport(csvCheck = 0) {
            if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.isLoading = true;
            var fr_date = '';
            var to_date = '';

            if (this.fromdate) {
                fr_date = this.dateFormat(this.fromdate)
            }
            if (this.todate) {
                to_date = this.dateFormat(this.todate)
            }
            var dataFilter = {};

            this.input = ({
                limit: this.pageLimit,
                todate: to_date,
                offset: (this.currentPage - 1) * 10,
                userid: this.userid,
                productid: this.ProductID.trim(),
                brand: this.brand,
                csvData: csvCheck,
                merchantid: this.merchantid,
                racktype: this.racktype,
                orderby: this.orderby,
                checkrack: this.withrackid
            });
            let client = this.client.toString()
            let warehouse = this.warehouse.toString()
            let Filterdwarehousename = this.listWarehouseData.filter(function (el) { return el.warehouseid == warehouse })
            let Filterdclientname = this.listClientData.filter(function (el) { return el.clientid == client });
            this.input.clientname = localStorage.getItem("selectedClient")
            this.input.warehousename = localStorage.getItem("selectedWarehouse")
            if (csvCheck == 2) {
                this.listProductRackData = []
                this.show = false;
                this.searchFlag1 = true;
                this.download = true;
                this.currentPage = 1;
            }
            Object.entries(this.input).forEach(([k, v]) => {
                let skipkeys = ['offset', 'limit', 'csvData'];
                if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
                    dataFilter[k] = v;
                }
            })
            delete this.input.clientname
            delete this.input.warehousename
            this.input.clientid = localStorage.getItem("selectedClient")
            this.input.warehouseid = localStorage.getItem("selectedWarehouse")
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'stockageingreport',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
                .then(result => {
                    this.searchFlag = true;

                    if (csvCheck == 1) {
                        if (result.data.data.length > 0) {
                            this.list = []
                            this.withrackid = document.getElementById("withracks").checked ? true : false
                            this.csvFields = {
                                'productid': this.$t('common.productId'),
                                'clientproductid': this.$t('product.clientProductId'),
                                'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
                                'productname': this.$t('printProductDetails.productName'),
                                'brand': this.$t('common.brand'),
                                'merchantname': this.$t('packingReportList.table.columns.merchantName'),
                                'racktype':  this.$t('editedjson.stockTyped'),
                                'quantity': this.$t('inwardList.printData.printBarcode.heading'),
                                'invreferenceid': this.$t('stockAgeingReport.table.drId'),
                                'age':  this.$t('editedjson.ageIndays'),
                                'drdatetime':  this.$t('removeHold.drDatetime'),

                            };
                            if (this.withrackid)
                                this.csvFields.rackid = 'Rack ID'
                            for (var i of result.data.data) {
                                var listDataCsv = {
                                    'productid': i.productid,
                                    'clientproductid': i.clientproductid,
                                    'eancode': i.eancode,
                                    'productname': i.productname,
                                    'brand': i.brand,
                                    'merchantname': i.merchantname,
                                    'racktype': i.racktype,
                                    'quantity': i.quantity,
                                    'invreferenceid': i.invreferenceid,
                                    'drdatetime': i.drdatetime,

                                }
                                if (this.withrackid)
                                    listDataCsv.rackid = i.rackid
                                if (i.diff.days && i.diff.days != undefined) {
                                    listDataCsv.age = i.diff.days
                                    // listDataCsv.drdatetime = moment(i.drdatetime).format('DD-MM-YYYY HH:mm:ss');
                                } else {
                                    listDataCsv.age = 0
                                    //  listDataCsv.drdatetime = moment(i.drdatetime).format('DD-MM-YYYY HH:mm:ss');
                                }
                                this.list.push(listDataCsv)
                            }
                            var dateFilter = [];
                            this.skipFilter = [];
                            csvHelper.data.jsonToCSV(this.$t('editedjson.Stockageingreport')
                            , this.list, this.csvFields, dateFilter, this.skipFilter, dataFilter);
                        }
                        else {
                            if (result.data.status == true || result.status == true) {
                                this.$alertify.success(this.$t('common.reportSizeError'));
                            }
                            else if (result.data.data.length == true) {
                                this.$alertify.success(this.$t('common.reportSizeError'));
                            }
                            else {
                                this.$alertify.error(result.data.msg.message);
                            }
                        }
                    } else {
                        if (result.data.count != 0 && result.data.status == true) {
                            for (var i of result.data.data) {

                                var listDataCsv = {
                                    'productid': i.productid,
                                    'clientproductid': i.clientproductid,
                                    'eancode': i.eancode,
                                    'productname': i.productname,
                                    'brand': i.brand,
                                    'merchantname': i.merchantname,
                                    'racktype': i.racktype,
                                    'quantity': i.quantity,
                                    'invreferenceid': i.invreferenceid,
                                    'drdatetime': i.drdatetime,
                                    'rackid': i.rackid

                                }
                                if (i.diff.days && i.diff.days != undefined) {
                                    listDataCsv.age = i.diff.days
                                } else {
                                    listDataCsv.age = 0
                                }
                                this.listProductRackData.push(listDataCsv)
                            }
                            // this.listProductRackData = result.data.data;
                            this.totalCount = result.data.count
                            this.resultCount = result.data.count;
                            this.totalRows = result.data.count
                            if (Number(this.totalRows) > Number(this.recordLimit)) {
                                this.limitExeed = true
                            } else {
                                this.limitExeed = false
                            }

                            if (this.totalCount < 10) {
                                this.totalPage = 1
                            } else {
                                this.totalPage = Math.ceil(this.totalCount / 10);
                            }
                        }
                        else {
                            this.totalCount = 0
                            this.isLoading = false;
                            if (result.data.status == false) {
                                this.$alertify.error(result.data.msg);
                            }
                        }

                    }
                    this.isLoading = false;
                },
                    error => {
                        console.error(error);
                    })
        },
        getRecordLimit() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({

            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getRecordLimit',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    if (result.data) {
                        this.recordLimit = result.data.data;


                    }
                }, error => {
                    console.error(error)
                })
        },
        getBrandlist() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
                clientid: localStorage.getItem("selectedClient"),
            })
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getBrandlist',
                'data': this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
            })
                .then(result => {
                    if (result.data.data && result.data.data.length > 0) {
                        this.listbrandData = result.data.data
                        this.brandList.push({
                            text: this.$t('common.selectBrandPlaceHolder')
                        }
                        )
                        for (var i = 0; i < this.listbrandData.length; i++) {
                            if (this.listbrandData[i].brand != undefined && this.listbrandData[i].brand != null && this.listbrandData[i].brand != '') {
                                this.brandList.push({
                                    'text': this.listbrandData[i].brand
                                });
                            }
                        }
                    }
                }, error => {
                    console.error(error)
                })
        },

        checkRackid(ev) {
            this.withrackid = document.getElementById("withracks").checked ? true : false
        },

        onPageChange(page) {
            this.currentPage = page;
            this.listProductRackData = []
            this.getStockageingReport()
        },

        //Reset the Search filter
        resetForm() {
            this.totalCount = 0;
            this.brand = ''
            this.selectedbrand = {},
                this.days = '',
                this.ProductID = '',
                this.fromdate = '',
                this.todate = '',
                this.searchFlag = false
            this.errormsg = ''
            this.orderby = 'DESC'
            this.merchantid = ''
            this.racktype = ''
            this.listProductRackData = [];
            this.selectedmerchant = {}
            this.$validator.reset();

            if (this.user_type == 'warehouse_user') {
                this.client = '';
                // this.merchantList = []
            }
            else if (this.user_type == 'client_user') {
                this.warehouse = '';
            }
            else {
                this.client = '';
                this.warehouse = '';
                // this.merchantList = []
            }
            this.withrackid = false
        },
        async validatevalues() {
            try {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.getNotinPOReportserach()
                    } else {
                        console.log("not valid")
                    }
                })
            }
            catch (err) {
                this.isLoading = false;
                this.$alert(err, "", "error");
                console.log(err);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/stockageingreport/stockageingreport.component.js